import {parallel} from '@gongxigames/framework/slotV2/fsm/acts/ActFactory';
import {UIState} from '@gongxigames/framework/slotV2/baseClasses/uiState/UIState';
import {BuyFeaturePopUpUIAct} from '@gongxigames/framework/slotV2/ui/acts/BuyFeaturePopUpUIAct';
import {BuyFeatureButtonHideUIAct} from '@gongxigames/framework/slotV2/ui/acts/BuyFeatureButtonHideUIAct';
import {slotStore} from '@gongxigames/framework/slotV2/globals';

export class BuyFeaturePopUpUIState extends UIState {
    public static readonly ID = 'BuyFeaturePopUpUIState';

    public setAct(): void {
        this.act = parallel([
            BuyFeatureButtonHideUIAct,
            BuyFeaturePopUpUIAct
        ]);
    }

    canExecute(): boolean {
        return slotStore.feature_type.value?.type === 'buyFeaturePopup';
    }
}